Base = App.loadClass 'core::Services/MapLayers/Base'

exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.Field', [
        # This is sorta annoying / hacky. Because this extends Base,
        # we have to be sure to inject all the same dependencies
        # as we did for Base. Which means if Base changes, we need
        # to update this list...
        '$http', 'Core.Services.Map', '$q', (args...) ->
            return {
                new: () ->
                    return new exports.FieldBoundary(args...)
            }

    ]


class exports.FieldBoundary extends Base
    url: 'backend/grower/fields/get-boundary'

    getGeoJSON: (response) =>
        if response.data.status.type is 'success'
            return response.data.data.boundary
